export default __webpack_public_path__ + "static/assets/db393c73e841816b6245153b015fab8e.png";